var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMessageLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6999 10.3388V22.8317L10.8734 19.7544C11.0413 19.5915 11.266 19.5005 11.4999 19.5005H21.7999C22.7028 19.5005 23.2999 18.9034 23.2999 18.0005V10.3005C23.2999 9.49755 22.6028 8.80049 21.7999 8.80049H9.2999C8.51872 8.80049 7.78184 9.48192 7.6999 10.3388ZM5.90255 10.2315C6.03553 8.50271 7.4904 7.00049 9.2999 7.00049H21.7999C23.597 7.00049 25.0999 8.50343 25.0999 10.3005V18.0005C25.0999 19.8975 23.697 21.3005 21.7999 21.3005H11.8646L8.83055 24.2426C8.27292 24.7952 7.51327 24.8192 6.95355 24.5759C6.39639 24.3336 5.8999 23.769 5.8999 23.0005V10.3005C5.8999 10.2775 5.90079 10.2544 5.90255 10.2315Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6999 13.4004C10.2999 13.8004 10.2999 14.5004 10.6999 15.0004C11.0999 15.4004 11.8999 15.4004 12.2999 15.0004C12.6999 14.6004 12.6999 13.8004 12.2999 13.4004C11.8999 12.9004 11.1999 12.9004 10.6999 13.4004Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7998 13.4004C14.2998 13.8004 14.2998 14.5004 14.7998 15.0004C15.1998 15.4004 15.9998 15.4004 16.3998 15.0004C16.7998 14.6004 16.7998 13.8004 16.3998 13.4004C15.8998 12.9004 15.1998 12.9004 14.7998 13.4004Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 13.4006C20 13.0006 19.2 13.0006 18.8 13.4006C18.4 13.8006 18.4 14.6006 18.8 15.0006C19.2 15.4006 20 15.4006 20.4 15.0006C20.9 14.5006 20.9 13.8006 20.4 13.4006Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessageLight);
export default __webpack_public_path__ + "static/media/icon_message_light.1c0a401a.svg";
export { ForwardRef as ReactComponent };